import { ImageElementType, ImageElement } from '../form_elements/image/ImageElement';
import { UnionElement } from '../form_elements/BaseElement';
import { RootElement } from '../form_elements/RootElement';

// Sanitizes form body before saving to backend.
// Ensures image_url is empty when s3_object_key is present to prevent
// persisting temporary presigned URLs to the database.
export function sanitizeFormBodyForSave(body: RootElement): RootElement {
  return {
    ...body,
    children: body.children.map(sanitizeElement)
  };
}

function sanitizeElement(element: UnionElement): UnionElement {
  // Handle image elements with s3_object_key
  if (element.type === ImageElementType) {
    const imageElement = element as ImageElement;
    if (imageElement.s3_object_key) {
      return {
        ...imageElement,
        image_url: ''
      };
    }
  }

  // Recursively sanitize children if present
  if ('children' in element && Array.isArray(element.children)) {
    return {
      ...element,
      children: element.children.map(sanitizeElement)
    };
  }

  return element;
}
